import { render, staticRenderFns } from "./MapPostCard.vue?vue&type=template&id=6449a138&scoped=true"
import script from "./MapPostCard.vue?vue&type=script&lang=js"
export * from "./MapPostCard.vue?vue&type=script&lang=js"
import style0 from "./MapPostCard.vue?vue&type=style&index=0&id=6449a138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449a138",
  null
  
)

export default component.exports